import styled from "styled-components";
import { CardContainer } from "./Table/TableCard/styles.ts";

export const CardTableWrapper = styled.section`
  padding: 96px 24px;
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:nth-of-type(even) {
    background: ${({ theme }) => theme.colors.default[50]};

    ${CardContainer} {
      background: ${({ theme }) => theme.colors.base};

      &[data-is-selected="true"] {
        background: ${({ theme }) => theme.colors.default[50]};
      }
    }
  }
`;

export const CardTableContent = styled.div`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  display: flex;
  gap: 24px;
  flex-direction: column;
`;

export const CardTableHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const CardTableHeaderLabel = styled.h2`
  font-size: 32px;
  color: ${({ theme }) => theme.colors.default[900]};
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.96px;
`;

export const CardTableFooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const TableContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  height: fit-content;
  min-height: 100px;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.base};
  z-index: 3;
`;
